import * as z from "zod/v4";

export const getLoyaltyLionFeaturesEnabled = {
  name: "getLoyaltyLionFeaturesEnabled" as const,
  input: z.null(),
  output: z.object({ enabled: z.boolean() }),
};
